// Main App component
import React, { useState, useEffect, useCallback } from 'react';
import Terminal from './components/ui/Terminal';
import ProfileCard3D from './components/ui/ProfileCard3D';
import TerminalHeader from './components/ui/TerminalHeader';
import StatusBar from './components/ui/StatusBar';
import CommandPalette from './components/ui/CommandPalette';
import { useTheme } from './hooks/useTheme';
import { useGitHub } from './hooks/useGitHub';
import './styles/themes.css';
import './App.css';

function App() {
  const { theme, setTheme } = useTheme();
  const github = useGitHub();
  const [paletteOpen, setPaletteOpen] = useState(false);

  const runCommand = useCallback((cmd) => {
    window.dispatchEvent(new CustomEvent('portfolio:run', { detail: cmd }));
  }, []);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setPaletteOpen((open) => !open);
      }
    };
    const onOpen = () => setPaletteOpen(true);

    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('portfolio:palette', onOpen);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('portfolio:palette', onOpen);
    };
  }, []);

  return (
    <div className="App">
      <TerminalHeader />

      <div className="app-layout">
        <div className="profile-section">
          <ProfileCard3D />
        </div>

        <div className="terminal-section">
          <Terminal theme={theme} setTheme={setTheme} github={github} />
        </div>
      </div>

      <StatusBar github={github} />

      <CommandPalette
        open={paletteOpen}
        onClose={() => setPaletteOpen(false)}
        onRun={runCommand}
      />
    </div>
  );
}

export default App;
